/**
 * 確認ダイアログシステムのUIコンポーネント
 */

import React from 'react';
import { useConfirmDialogStore } from '../stores/confirmDialogStore';
import { Dialog } from './common/Dialog';
import { Button } from './common/Button';
import * as styles from './ConfirmDialogSystem.css.ts';

/**
 * 確認ダイアログシステムのメインコンポーネント
 * App.tsxのルートレベルで一度だけレンダリングする
 */
export const ConfirmDialogSystem: React.FC = () => {
  const isOpen = useConfirmDialogStore(state => state.isOpen);
  const options = useConfirmDialogStore(state => state.options);
  const close = useConfirmDialogStore(state => state.close);

  if (!options) {
    return null;
  }

  const handleConfirm = () => {
    close(true);
  };

  const handleCancel = () => {
    close(false);
  };

  // ボタンのスタイルをマッピング
  const getButtonVariant = (style: string | undefined): 'primary' | 'secondary' | 'danger' => {
    if (style === 'danger') return 'danger';
    if (style === 'secondary') return 'secondary';
    return 'primary';
  };

  return (
    <Dialog
      isOpen={isOpen}
      onClose={handleCancel}
      title={options.title || 'Confirm'}
      width="md"
      closeOnOverlayClick={false}
      showCloseButton={true}
      data-testid={options.testId || 'confirm-dialog'}
      footer={
        <>
          <Button
            variant="secondary"
            onClick={handleCancel}
            data-testid="confirm-dialog-cancel"
          >
            {options.cancelLabel || 'Cancel'}
          </Button>
          <Button
            variant={getButtonVariant(options.confirmStyle)}
            onClick={handleConfirm}
            data-testid="confirm-dialog-confirm"
          >
            {options.confirmLabel || 'OK'}
          </Button>
        </>
      }
    >
      <div className={styles.content}>
        <p className={styles.message}>{options.message}</p>

        {options.details && (
          <div className={styles.details}>
            {options.details}
          </div>
        )}

        {options.extraContent && (
          <div className={styles.extraContent}>
            {options.extraContent}
          </div>
        )}
      </div>
    </Dialog>
  );
};
